import { BACKGROUND_IMAGE_SELECTED } from '../../action-types/ui/backgroundImageSelected';

export const STATE_KEY = 'backgroundImageSelected';

export const backgroundImageSelected = (state = false, action) => {
  switch (action.type) {
    case BACKGROUND_IMAGE_SELECTED: {
      return action.flag;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/backgroundImageSelected.js.js